import { FC } from 'react';
import { gradeContentsMap } from '@components/phs/pst/results/result/gradeInfo/data';
import { gradeList, gradeTextSelectMap, GradeType } from '@domain/constant/gradeType';

import classnames from 'classnames/bind';
import styles from './gradeList.module.scss';

const cx = classnames.bind(styles);

interface GradeListProps {
  grade: GradeType;
}

const GradeList: FC<GradeListProps> = ({ grade }) => {
  const gradeImgEls = gradeList.map((value) => {
    return (
      <div key={value} className={cx('imgArea')}>
        <img
          className={cx('gradeImg', { big: grade === value })}
          src={gradeContentsMap[value].imgSrc}
          alt={gradeTextSelectMap[value]}
        />
        {grade === value ? (
          <div className={cx('tooltip')}>
            달성 등급
            <em className={cx('grade')}>{gradeTextSelectMap[value]}</em>
          </div>
        ) : (
          <em className={cx('title', value)}>{gradeTextSelectMap[value]}</em>
        )}
      </div>
    );
  });

  return <div className={cx('gradeListArea')}>{gradeImgEls}</div>;
};

export default GradeList;
